import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import DataApi from '../../api/DataApi';

const AudienceModal = ({
  show,
  onHide,
  objectName,
  recordData,
  getNameFromDetails
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const [listViewData, setListViewData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedListView, setSelectedListView] = useState('');
  const [selectedObj, setSelectedObj] = useState('');
  const [objects, setObjects] = useState([]);
  const [listViews, setListViews] = useState([]);
  // List view audience state
  // Fetch objects for the dropdown
  useEffect(() => {
    if (show) {
      // In a real implementation, this would fetch from an API
      // For now, using mock data
      setObjects([
        { value: 'lead', label: 'Leads' },
        { value: 'contact', label: 'Contacts' }
      ]);

    }
  }, [show]);

  // When object is selected, fetch list views for that object
  useEffect(() => {
    if (selectedObj) {
      // Fetch list views from API
      const fetchListViews = async () => {
        setIsLoading(true);
        try {
          const listViewApi = new DataApi(`objectconfig/listviews/${selectedObj}`);
          const response = await listViewApi.fetchAll();
          console.log('Response:', response);
          if (response?.data?.success && response.data.data) {
            const fetchedListViews = response.data.data.map(view => ({
              value: view.name,
              label: view.label || view.name
            }));
            setListViews(fetchedListViews);
          } else {
            // Fallback to mock data if API fails
            const mockListViews = {
              lead: [
                { value: 'all_leads', label: 'All Leads' },
                { value: 'active_leads', label: 'Active Leads' },
                { value: 'web_leads', label: 'Web Leads' },
                { value: 'today_leads', label: "Today's Leads" }
              ],
              contact: [
                { value: 'all_contacts', label: 'All Contacts' },
                { value: 'active_contacts', label: 'Active Contacts' },
                { value: 'recent_contacts', label: 'Recent Contacts' }
              ],
              account: [
                { value: 'all_accounts', label: 'All Accounts' },
                { value: 'active_accounts', label: 'Active Accounts' },
                { value: 'prospect_accounts', label: 'Prospect Accounts' }
              ],
              opportunity: [
                { value: 'all_opportunities', label: 'All Opportunities' },
                { value: 'open_opportunities', label: 'Open Opportunities' },
                { value: 'closed_won', label: 'Closed Won' },
                { value: 'closed_lost', label: 'Closed Lost' }
              ]
            };

            setListViews(mockListViews[selectedObj] || []);
          }
        } catch (error) {
          console.error('Error fetching list views:', error);
          // Fallback to mock data if API fails
          const mockListViews = {
            lead: [
              { value: 'all_leads', label: 'All Leads' },
              { value: 'active_leads', label: 'Active Leads' },
              { value: 'web_leads', label: 'Web Leads' },
              { value: 'today_leads', label: "Today's Leads" }
            ],
            contact: [
              { value: 'all_contacts', label: 'All Contacts' },
              { value: 'active_contacts', label: 'Active Contacts' },
              { value: 'recent_contacts', label: 'Recent Contacts' }
            ],
            account: [
              { value: 'all_accounts', label: 'All Accounts' },
              { value: 'active_accounts', label: 'Active Accounts' },
              { value: 'prospect_accounts', label: 'Prospect Accounts' }
            ],
            opportunity: [
              { value: 'all_opportunities', label: 'All Opportunities' },
              { value: 'open_opportunities', label: 'Open Opportunities' },
              { value: 'closed_won', label: 'Closed Won' },
              { value: 'closed_lost', label: 'Closed Lost' }
            ]
          };

          setListViews(mockListViews[selectedObj] || []);
        } finally {
          setIsLoading(false);
        }
      };

      fetchListViews();
    } else {
      setListViews([]);
    }
  }, [selectedObj]);

  const handleObjectChange = (e) => {
    const newObject = e.target.value;
    setSelectedObj(newObject);
    setSelectedListView(''); // Reset list view when object changes
    setListViewData([]);
    setTotalRecords(0);

    // Notify parent component about object selection
    // if (onObjectSelect) {
    //   onObjectSelect(newObject);
    // }
  };

  const handleListViewChange = (e) => {
    const newListView = e.target.value;
    console.log("newListView =>", newListView);

    setSelectedListView(newListView);
    // Fetch records for the selected list view
    if (newListView && selectedObj) {
      fetchListViewRecords(selectedObj, newListView);
    } else {
      setListViewData([]);
      setTotalRecords(0);
    }
  };

  // Function to fetch records for a specific list view
  const fetchListViewRecords = async (objectName, listViewName) => {
    setIsLoading(true);
    try {
      const listViewApi = new DataApi(`object/listview/${objectName}/${listViewName}`);
      const queryParams = new URLSearchParams();
      queryParams.append("limit", 5); // Limit to 5 records for preview
      queryParams.append("offset", 0);
      queryParams.append("platform", "web");

      const result = await listViewApi.fetchAll(queryParams.toString());
      console.log("Result:", result);
      if (result?.data?.success) {
        const records = result.data.data.records;
        setListViewData(records);
        setTotalRecords(result.data.data.total || records.length);
      } else {
        console.error("Failed to fetch list view records:", result?.data?.message);
        setListViewData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching list view records:", error);
      setListViewData([]);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Audience</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="audience-section">
          <div className="d-flex align-items-center mb-3">
            <h5 className="mb-0 me-2"><strong>Email Campaign:</strong> {getNameFromDetails?.() || 'Diwali Sale'}</h5>
            {/* <span className="badge"><i className='fa fa-edit fa-xl'></i></span> */}
          </div>

          {/* <div className="d-flex gap-2 mb-4">
            <Button variant="outline-primary" size="sm">Send Test</Button>
            <Button variant="outline-primary" size="sm">Schedule</Button>
            <Button variant="success" size="sm">Activate</Button>
          </div> */}

          <div className="card mb-4">
            <div className="card-body">
              <h6 className="card-title mb-3">Audience</h6>

              <Form.Group className="mb-3">
                <Form.Label>Select Object</Form.Label>
                <Form.Select
                  value={selectedObj}
                  onChange={handleObjectChange}
                  disabled={isLoading}
                >
                  <option value="">Select an object</option>
                  {objects.map((obj) => (
                    <option key={obj.value} value={obj.value}>
                      {obj.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {selectedObj && (
                <Form.Group className="mb-3">
                  <Form.Label>Select List View</Form.Label>
                  <Form.Select
                    value={selectedListView}
                    onChange={handleListViewChange}
                    disabled={isLoading}
                  >
                    <option value="">Select a list view</option>
                    {listViews.map((view) => (
                      <option key={view.value} value={view.value}>
                        {view.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}

              {listViewData && listViewData.length > 0 && (
                <div className="list-view-preview">
                  <h6 className="mb-2">List View Preview</h6>
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered">
                      <thead>
                        <tr>
                          {Object.keys(listViewData[0]).slice(0, 4).map(key => (
                            <th key={key}>{key.charAt(0).toUpperCase() + key.slice(1)}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {listViewData.slice(0, 5).map((item, index) => (
                          <tr key={index}>
                            {Object.values(item).slice(0, 4).map((value, idx) => (
                              <td key={idx}>{value}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {totalRecords !== undefined && (
                <div className="mt-3 pt-3 border-top">
                  <div className="d-flex justify-content-between">
                    <span><strong>Total Records:</strong></span>
                    <span><strong>{totalRecords.toLocaleString()}</strong></span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            // Perform save action
            onHide();
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};

export default AudienceModal;
